import { render, staticRenderFns } from "./TransferDomain.vue?vue&type=template&id=4479998c&scoped=true&"
import script from "./TransferDomain.vue?vue&type=script&lang=ts&"
export * from "./TransferDomain.vue?vue&type=script&lang=ts&"
import style0 from "./TransferDomain.vue?vue&type=style&index=0&id=4479998c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479998c",
  null
  
)

export default component.exports